import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { Theme, GlobalStyle } from "./config/aws-exports";
import About from "./pages/About/About";
import Dashboard from "./pages/Dashboard/Dashboard";
import Home from "./pages/Home/Home";
import LiveSession from "./pages/LiveSession/LiveSession";
import Profile from "./pages/Profile/Profile";
import Calendar from "./pages/Calendar/Calendar";
import Notifications from "./pages/Notifications/Notifications";
import Course from "./pages/Course/Course";

import { useSelector } from "react-redux";
import { authData } from "./redux/auth/authSlice";
import Bookmark from "./pages/Bookmark/Bookmark";
import Wishlist from "./pages/WishList/Wishlist";
import Search from "./pages/Search/Search";
import SearchPrelogin from "./pages/Search/SerachPrelogin";
import ViewAllSession from "./pages/LiveSession/ViewAllSession/ViewAllSession";
import ViewAllCourses from "./pages/Course/ViewAllCourses/ViewAllCourses";
import PreViewAll from "./pages/PreLoginTopic/PreViewAll";
import Certificate from "./pages/Certificate/Certificate";
import Invoices from "./pages/Invoices/Invoices";
import PreLoginLiveSession from "./pages/PreLoginPage/LiveSession";
import ViewAll from "./pages/ViewAll/ViewAll";
import Help from "./pages/Help/Help";
import Layout from "./components/Layout/Layout";
import PreLoginCourse from "./pages/PreLoginCourse/PreLoginCourse";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

const App = () => {
  const userDetails = useSelector(authData);

  return (
    <ThemeProvider theme={Theme}>
      <GlobalStyle />
      <Router>
        <ScrollToTop />
        {userDetails === 0 ? (
          <>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/prelogin" element={<PreLoginLiveSession />} />
              <Route path="/session" element={<PreLoginLiveSession />} />
              <Route path="/preCourse" element={<PreLoginCourse />} />
              <Route path="/previewall" element={<PreViewAll />} />
              <Route path="*" element={<Home />} />
              
              <Route path="/resultspre" element={<SearchPrelogin />} />
            </Routes>
          </>
        ) : (
          <Layout>
            <Routes>
              <Route
                path="/"
                element={
                  userDetails !== 0 ? <Navigate to="/dashboard" /> : <Home />
                }
              />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/session" element={<LiveSession />} />
              <Route path="/course" element={<Course />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/bookmark" element={<Bookmark />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/results" element={<Search />} />
              <Route path="/allSessions" element={<ViewAllSession />} />
              <Route path="/allCourses" element={<ViewAllCourses />} />
              <Route path="/certificates" element={<Certificate />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/helpandsupport" element={<Help />} />
              <Route path="/viewall" element={<ViewAll />} />
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </Layout>
        )}
      </Router>
    </ThemeProvider>
  );
};

export default App;
